export const FeedbackIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask id='path-1-inside-1_2058_1863' fill='white'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 3C3.89543 3 3 3.89543 3 5V14.9582C3 16.0628 3.89543 16.9582 5 16.9582H14.9756L19.3441 20.7538C19.9914 21.3163 21 20.8565 21 19.999V14.9582V14.8811V13.5963V5C21 3.89543 20.1046 3 19 3H5Z'
      />
    </mask>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 3C3.89543 3 3 3.89543 3 5V14.9582C3 16.0628 3.89543 16.9582 5 16.9582H14.9756L19.3441 20.7538C19.9914 21.3163 21 20.8565 21 19.999V14.9582V14.8811V13.5963V5C21 3.89543 20.1046 3 19 3H5Z'
      fillOpacity='var(--nav-icon-fill-opacity, 0)'
      fill='currentColor'
    />
    <path
      d='M14.9756 16.9582L15.7955 16.0146L15.4428 15.7082H14.9756V16.9582ZM19.3441 20.7538L20.164 19.8103H20.164L19.3441 20.7538ZM4.25 5C4.25 4.58579 4.58579 4.25 5 4.25V1.75C3.20507 1.75 1.75 3.20508 1.75 5H4.25ZM4.25 14.9582V5H1.75V14.9582H4.25ZM5 15.7082C4.58579 15.7082 4.25 15.3724 4.25 14.9582H1.75C1.75 16.7532 3.20507 18.2082 5 18.2082V15.7082ZM14.9756 15.7082H5V18.2082H14.9756V15.7082ZM14.1558 17.9018L18.5243 21.6974L20.164 19.8103L15.7955 16.0146L14.1558 17.9018ZM18.5243 21.6974C19.9807 22.9629 22.25 21.9284 22.25 19.999H19.75C19.75 19.7846 20.0021 19.6697 20.164 19.8103L18.5243 21.6974ZM22.25 19.999V14.9582H19.75V19.999H22.25ZM22.25 14.9582V14.8811H19.75V14.9582H22.25ZM22.25 14.8811V13.5963H19.75V14.8811H22.25ZM19.75 5V13.5963H22.25V5H19.75ZM19 4.25C19.4142 4.25 19.75 4.58579 19.75 5H22.25C22.25 3.20507 20.7949 1.75 19 1.75V4.25ZM5 4.25H19V1.75H5V4.25Z'
      fill='currentColor'
      mask='url(#path-1-inside-1_2058_1863)'
    />
    <path
      d='M8 8H16M9.2 12H16'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
